/* eslint-disable */
import { Typography } from '@mui/material';
import React from 'react';
import { Chart } from 'react-google-charts';
import {
  GraphicsContainerStyled,
  GraphicsStyled,
  UsersProfileStyled,
} from './DashboardSuperAdmin.styles';

const usersData = [
  ['MÊS', 'QUANTIDADE DE USUÁRIOS', { role: 'style' }],
  ['JAN', 50, '#248ded'],
  ['FEV', 30, '#248ded'],
  ['MAR', 70, '#248ded'],
  ['ABR', 45, '#248ded'],
  ['MAI', 82, '#248ded'],
  ['JUN', 95, '#248ded'],
];
const billingData = [
  ['MÊS', 'VALOR', { role: 'style' }],
  ['JUN', 1500, '#5ACAC8'],
  ['JUL', 3000, '#5ACAC8'],
  ['AGO', 3000, '#5ACAC8'],
  ['SET', 30000, '#5ACAC8'],
  ['OUT', 60000, '#5ACAC8'],
  ['NOV', 45000, '#5ACAC8'],
];
const pieChart = [
  ['Task', 'Hours per Day'],
  ['Espaço adquirido (2GB)', 25],
  ['Espaço utilizado', 75],
];
const optionColumChart = {
  width: '100%',
  backgroundColor: {
    fill: 'transparent',
  },
  hAxis: {
    textStyle: {
      color: 'white',
      fontName: 'montserrat',
    },
  },
  vAxis: {
    gridlines: {
      color: '#2B3550',
    },
  },
  legend: {
    position: 'bottom',
    textStyle: {
      color: '#fff',
      fontName: 'montserrat',
    },
  },
};
const optionPieChart = {
  pieSliceText: 'none',
  pieHole: 0.4,
  pieSliceBorderColor: 'none',
  backgroundColor: 'transparent',
  colors: ['#5ACAC8', '#248ded'],
  legend: {
    position: 'bottom',
    textStyle: {
      color: '#FFF',
      fontName: 'montserrat',
    },
  },
};

export function DashboardSuperAdmin() {
  return (
    <div>
      <GraphicsContainerStyled>
        <GraphicsStyled>
          <Typography variant="h4">Perfil dos usuários</Typography>
          <div>
            <UsersProfileStyled>
              <p>
                Usuários ativos:{' '}
                <strong style={{ color: '#5ACAC8' }}>60</strong>
              </p>
              <p className="link">Enviar mensagem para grupo</p>
            </UsersProfileStyled>
            <hr />
            <UsersProfileStyled>
              <p>
                Usuários em atraso:{' '}
                <strong style={{ color: '#5ACAC8' }}>8</strong>
              </p>
              <p className="link">Enviar mensagem para grupo</p>
            </UsersProfileStyled>
            <hr />
            <UsersProfileStyled>
              <p>
                Usuários em período de teste:{' '}
                <strong style={{ color: '#5ACAC8' }}>10</strong>
              </p>
              <p className="link">Enviar mensagem para grupo</p>
            </UsersProfileStyled>
            <hr />
            <UsersProfileStyled>
              <p>
                Usuários ausentes (20 dias):{' '}
                <strong style={{ color: '#5ACAC8' }}>3</strong>
              </p>
              <p className="link">Enviar mensagem para grupo</p>
            </UsersProfileStyled>
            <hr />
          </div>
          <p>
            <strong style={{ color: '#5ACAC8' }}>*</strong>Clique na descrição
            de cada perfil do usuário para ter o detalhamento completo
          </p>
        </GraphicsStyled>
        <GraphicsStyled>
          <Typography variant="h4">Número de usuários ativos</Typography>
          <div style={{ width: '100%', maxHeight: 250, color: 'white' }}>
            <Chart
              chartType="ColumnChart"
              data={usersData}
              options={optionColumChart}
            />
          </div>
        </GraphicsStyled>
        <GraphicsStyled>
          <Typography variant="h4">Faturamento</Typography>
          <div style={{ width: '100%', maxHeight: 250 }}>
            <Chart
              chartType="ColumnChart"
              data={billingData}
              options={optionColumChart}
            />
          </div>
        </GraphicsStyled>
        <GraphicsStyled>
          <Typography variant="h4">Espaço utilizado pelos usuários</Typography>
          <div style={{ width: '100%', maxHeight: 250 }}>
            <Chart
              chartType="PieChart"
              data={pieChart}
              options={optionPieChart}
            />
          </div>
        </GraphicsStyled>
      </GraphicsContainerStyled>
    </div>
  );
}
